import { render, staticRenderFns } from "./labour.vue?vue&type=template&id=f0a7a62e&scoped=true&"
import script from "./labour.vue?vue&type=script&lang=js&"
export * from "./labour.vue?vue&type=script&lang=js&"
import style0 from "./labour.vue?vue&type=style&index=0&id=f0a7a62e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a7a62e",
  null
  
)

export default component.exports